import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useApp } from 'providers';
import { TRACKING_CLICKS } from 'api';
import { useClickTracking, useErrorParam } from 'hooks';
import { loginValidationSchema } from './validationSchema';
import { LoginFormView } from './LoginFormView';

export const LoginForm = (): React.ReactElement => {
  const { login } = useApp();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const track = useClickTracking(TRACKING_CLICKS.CONNEXION);
  const {
    errors,
    values: { email, password },
    isSubmitting,
    handleChange,
    handleSubmit,
    touched,
  } = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginValidationSchema,
    onSubmit: (values, { setSubmitting }) => {
      login(values.email, values.password)
        .then(track)
        .catch(r => {
          if (typeof r === 'string') {
            setErrorMessage(r);
          } else {
            setErrorMessage(r?.message);
          }
        })
        .finally(() => setSubmitting(false));
    },
  });

  const error = useErrorParam(false);
  useEffect(() => {
    if (error) {
      setErrorMessage(error.message);
    }
  }, [error]);

  return (
    <LoginFormView
      email={email}
      password={password}
      isSubmitting={isSubmitting}
      errorMessage={errorMessage}
      touched={touched}
      errors={errors}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
};
